
import useConfigRepo from "services/repo/useConfigRepo";
import DevLog from "utils/DevLog";
import { RSAEncript } from "utils/HelperEncript";

export default function useEncriptRSAHook() {
    const { getRSAPublicKey } = useConfigRepo(false);

    const getEncriptedText = async (text) => {
        let response = await getRSAPublicKey();
        if (response?.isValid && response?.statusCode === 200) {
            let data = response.data
            try {
                return RSAEncript(data.modulus, data.exponent, text)
            } catch (error) {
                DevLog("Error encript.")
                return false
            }
        }
    }

    return {
        getEncriptedText
    }
}
